import { dispatchMFEAdobeEvent } from './events'

export const CARD_DETAILS_ISSUE_1 = [
  '1',
  '2',
  '13',
  '15',
  '37',
  '57',
  '61',
  '65',
  '83',
]

export const INVALID_TRANSACTION = ['12', '23']

export const PICKUP_CARD = ['4', '7']

export const GENERAL_ERROR = ['5', '6']

export const PLEASE_TRY_AGAIN = ['0', 'APC_054', '3', '100', '1043', '1052']

export const INSUFFICIENT_FUNDS = ['16', '51']

export const CARD_DETAILS_ISSUE_2 = ['14', '82', 'N7']

export const BLOCKED_CARD = ['78']

export const CUSTOMER_CANCELLATION = ['17']

export const FORMAT_ERROR = ['30']
export const AUTHENTICATION_FAILED = ['1A', '34', '35', '36', 'Q1']

export const CARD_DETAILS_ISSUE_3 = ['52', '53']
export const CARD_EXPIRED = ['54']

export const INCORRECT_PIN = ['55', '81']
export const MANY_PIN_TRIES = ['75']
export const CARD_EXPIRY_DATE_INVALID = ['86']
export const AVS_CHECK_FAILED = ['87']
export const INVALID_BILLER_INFO = ['P2']
export const TRANSACTION_NOT_ALLOWED_TERMINAL = ['58']

export const ERROR_DETOKENISE_TOKEN = ['1012']
export const NON_3DS_CARDS = ['OPP-2032', '13']

export const ERRORS_TEXT = {
  CARD_DETAILS_ISSUE_1: 'CARD_DETAILS_ISSUE_1',
  INVALID_TRANSACTION: 'INVALID_TRANSACTION',
  PICKUP_CARD: 'PICKUP_CARD',
  GENERAL_ERROR: 'GENERAL_ERROR',
  PLEASE_TRY_AGAIN: 'PLEASE_TRY_AGAIN',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  CARD_DETAILS_ISSUE_2: 'CARD_DETAILS_ISSUE_2',
  BLOCKED_CARD: 'BLOCKED_CARD',
  CUSTOMER_CANCELLATION: 'CUSTOMER_CANCELLATION',
  FORMAT_ERROR: 'FORMAT_ERROR',
  AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
  CARD_DETAILS_ISSUE_3: 'CARD_DETAILS_ISSUE_3',
  CARD_EXPIRED: 'CARD_EXPIRED',
  INCORRECT_PIN: 'INCORRECT_PIN',
  MANY_PIN_TRIES: 'MANY_PIN_TRIES',
  CARD_EXPIRY_DATE_INVALID: 'CARD_EXPIRY_DATE_INVALID',
  AVS_CHECK_FAILED: 'AVS_CHECK_FAILED',
  INVALID_BILLER_INFO: 'INVALID_BILLER_INFO',
  TRANSACTION_NOT_ALLOWED_TERMINAL: 'TRANSACTION_NOT_ALLOWED_TERMINAL',
  ERROR_DETOKENISE_TOKEN: 'ERROR_DETOKENISE_TOKEN',
  NON_3DS_CARDS: 'NON_3DS_CARDS',
  ALL_OTHERS: 'ALL_OTHERS_ERRORS',
}

/**
 * Provides error text depends on APEXX errorCode
 * @param l10n
 * @param errorStatus
 * @returns {string}
 */
export const APEXX_RESPONSE_ERROR_TEXT = (l10n, errorStatus) => {
  if (CARD_DETAILS_ISSUE_1.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-PaymentDeclined')
    return l10n.t(ERRORS_TEXT.CARD_DETAILS_ISSUE_1)
  }

  if (INVALID_TRANSACTION.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-PaymentDeclined')
    return l10n.t(ERRORS_TEXT.INVALID_TRANSACTION)
  }

  if (PICKUP_CARD.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-PaymentDeclined')
    return l10n.t(ERRORS_TEXT.PICKUP_CARD)
  }

  if (GENERAL_ERROR.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-PleaseTryAgain')
    return l10n.t(ERRORS_TEXT.GENERAL_ERROR)
  }

  if (PLEASE_TRY_AGAIN.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-IssueWithPayment')
    return l10n.t(ERRORS_TEXT.PLEASE_TRY_AGAIN)
  }

  if (INSUFFICIENT_FUNDS.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-UnsuccessfulPayment')
    return l10n.t(ERRORS_TEXT.INSUFFICIENT_FUNDS)
  }

  if (CARD_DETAILS_ISSUE_2.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-ReviewCardDetails')
    return l10n.t(ERRORS_TEXT.CARD_DETAILS_ISSUE_2)
  }

  if (BLOCKED_CARD.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-ContactBank')
    return l10n.t(ERRORS_TEXT.BLOCKED_CARD)
  }

  if (CUSTOMER_CANCELLATION.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-UnsuccessfulPayment')
    return l10n.t(ERRORS_TEXT.CUSTOMER_CANCELLATION)
  }

  if (FORMAT_ERROR.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-UnsuccessfulPayment')
    return l10n.t(ERRORS_TEXT.FORMAT_ERROR)
  }

  if (AUTHENTICATION_FAILED.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-AuthentificationFailed')
    return l10n.t(ERRORS_TEXT.AUTHENTICATION_FAILED)
  }

  if (CARD_DETAILS_ISSUE_3.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-ReviewCardDetails')
    return l10n.t(ERRORS_TEXT.CARD_DETAILS_ISSUE_3)
  }

  if (CARD_EXPIRED.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-CardExpired')
    return l10n.t(ERRORS_TEXT.CARD_EXPIRED)
  }

  if (INCORRECT_PIN.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-IncorrectPin')
    return l10n.t(ERRORS_TEXT.INCORRECT_PIN)
  }

  if (MANY_PIN_TRIES.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-ContactBank')
    return l10n.t(ERRORS_TEXT.MANY_PIN_TRIES)
  }

  if (CARD_EXPIRY_DATE_INVALID.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-CardInvalid')
    return l10n.t(ERRORS_TEXT.CARD_EXPIRY_DATE_INVALID)
  }

  if (AVS_CHECK_FAILED.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-IssueWithAddress')
    return l10n.t(ERRORS_TEXT.AVS_CHECK_FAILED)
  }

  if (INVALID_BILLER_INFO.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-IssueWithBilling')
    return l10n.t(ERRORS_TEXT.INVALID_BILLER_INFO)
  }

  if (TRANSACTION_NOT_ALLOWED_TERMINAL.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-IssueWithCardDetails')
    return l10n.t(ERRORS_TEXT.TRANSACTION_NOT_ALLOWED_TERMINAL)
  }

  if (ERROR_DETOKENISE_TOKEN.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-DetokeniseToken')
    return l10n.t(ERRORS_TEXT.ERROR_DETOKENISE_TOKEN)
  }

  if (NON_3DS_CARDS.includes(errorStatus)) {
    dispatchMFEAdobeEvent('Error-IssueWithCardDetails')
    return l10n.t(ERRORS_TEXT.NON_3DS_CARDS)
  }

  dispatchMFEAdobeEvent('Error-IssueWithPayment')
  return l10n.t(ERRORS_TEXT.ALL_OTHERS)
}
